module.exports = __webpack_public_path__ + "img/email.aaca12c5.svg";